export const KITCHEN = {
  GET_DATA_KITCHEN_SUCCESS: "GET_DATA_KITCHEN_SUCCESS",
  LOADING_DATA_KITCHEN_SUCCESS: "LOADING_DATA_KITCHEN_SUCCESS",
};

export const LOCATIONS = {
  GET_DATA_LOCATION_SUCCESS: "GET_DATA_LOCATION_SUCCESS",
  LOADING_DATA_LOCATION_SUCCESS: "LOADING_DATA_LOCATION_SUCCESS",
  LOADING_POST_LOCATION_SUCCESS: "LOADING_POST_LOCATION_SUCCESS",

  GET_DATA_LOCATION_POINT_SUCCESS: "GET_DATA_LOCATION_POINT_SUCCESS",
  LOADING_DATA_LOCATION_POINT_SUCCESS: "LOADING_DATA_LOCATION_POINT_SUCCESS",
  LOADING_POST_LOCATION_POINT_SUCCESS: "LOADING_POST_LOCATION_POINT_SUCCESS",

  GET_DATA_LOCATION_FEE_SUCCESS: "GET_DATA_LOCATION_FEE_SUCCESS",
  LOADING_DATA_LOCATION_FEE_SUCCESS: "LOADING_DATA_LOCATION_FEE_SUCCESS",
  LOADING_POST_LOCATION_FEE_SUCCESS: "LOADING_POST_LOCATION_FEE_SUCCESS",
};

export const BANKS = {
  GET_DATA_BANKS_SUCCESS: "GET_DATA_BANKS_SUCCESS",
  LOADING_DATA_BANKS_SUCCESS: "LOADING_DATA_BANKS_SUCCESS",
};

export const CASHIER = {
  GET_DATA_CASHIER_SUCCESS: "GET_DATA_CASHIER_SUCCESS",
  LOADING_DATA_CASHIER_SUCCESS: "LOADING_DATA_CASHIER_SUCCESS",
  LOADING_POST_CASHIER_SUCCESS: "LOADING_POST_CASHIER_SUCCESS",
};

export const VOUCHER = {
  GET_DATA_VOUCHER_SUCCESS: "GET_DATA_VOUCHER_SUCCESS",
  LOADING_DATA_VOUCHER_SUCCESS: "LOADING_DATA_VOUCHER_SUCCESS",
  LOADING_POST_VOUCHER_SUCCESS: "LOADING_POST_VOUCHER_SUCCESS",
};

export const DEALER = {
  GET_DATA_DEALER_SUCCESS: "GET_DATA_DEALER_SUCCESS",
  LOADING_DATA_DEALER_SUCCESS: "LOADING_DATA_DEALER_SUCCESS",
  LOADING_POST_DEALER_SUCCESS: "LOADING_POST_DEALER_SUCCESS",
};

export const VERIFIKASI_USER = {
  GET_DATA_VERIFIKASI_USER_SUCCESS: "GET_DATA_VERIFIKASI_USER_SUCCESS",
  LOADING_DATA_VERIFIKASI_USER_SUCCESS: "LOADING_DATA_VERIFIKASI_USER_SUCCESS",
  LOADING_POST_VERIFIKASI_USER_SUCCESS: "LOADING_POST_VERIFIKASI_USER_SUCCESS",
};

export const REKAP_TRANSAKSI = {
  GET_DATA_REKAP_TRANSAKSI_USER_SUCCESS:
    "GET_DATA_REKAP_TRANSAKSI_USER_SUCCESS",
  LOADING_DATA_REKAP_TRANSAKSI_USER_SUCCESS:
    "LOADING_DATA_REKAP_TRANSAKSI_USER_SUCCESS",
  DOWNLOAD_DANA_POTONGAN: "DOWNLOAD_DANA_POTONGAN",
  LOADING_DOWNLOAD_DANA_POTONGAN: "LOADING_DOWNLOAD_DANA_POTONGAN",
};

export const SIMPANAN_SUKARELA = {
  GET_DATA_SIMPANAN_SUKARELA_SUCCESS: "GET_DATA_SIMPANAN_SUKARELA_SUCCESS",
  LOADING_DATA_SIMPANAN_SUKARELA_SUCCESS:
    "LOADING_DATA_SIMPANAN_SUKARELA_SUCCESS",

  LOADING_ACTION_SIMPANAN_SUKARELA: "LOADING_ACTION_SIMPANAN_SUKARELA",
  IS_MODAL_ACTION_SIMPANAN_SUKARELA: "IS_MODAL_ACTION_SIMPANAN_SUKARELA",
  SET_QUERY_KEY: "SUKARELA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SUKARELA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SUKARELA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SUKARELA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SUKARELA_UPDATE_CACHE_ITEMS",
};

export const SIMPANAN_HARI_RAYA = {
  GET_DATA_SIMPANAN_HARI_RAYA_SUCCESS: "GET_DATA_SIMPANAN_HARI_RAYA_SUCCESS",
  LOADING_DATA_SIMPANAN_HARI_RAYA_SUCCESS:
    "LOADING_DATA_SIMPANAN_HARI_RAYA_SUCCESS",

  LOADING_ACTION_SIMPANAN_HARI_RAYA: "LOADING_ACTION_SIMPANAN_HARI_RAYA",
  IS_MODAL_ACTION_SIMPANAN_HARI_RAYA: "IS_MODAL_ACTION_SIMPANAN_HARI_RAYA",
  SET_QUERY_KEY: "HARI_RAYA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "HARI_RAYA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "HARI_RAYA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "HARI_RAYA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "HARI_RAYA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "HARI_RAYA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "HARI_RAYA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "HARI_RAYA_UPDATE_CACHE_ITEMS",

  // Event-driven actions
  WITHDRAWAL_APPROVE_REQUESTED: "WITHDRAWAL_APPROVE_REQUESTED",
  WITHDRAWAL_REJECT_REQUESTED: "WITHDRAWAL_REJECT_REQUESTED",
  WITHDRAWAL_ACTION_COMPLETED: "WITHDRAWAL_ACTION_COMPLETED",
  WITHDRAWAL_ACTION_FAILED: "WITHDRAWAL_ACTION_FAILED",
  DATA_REFRESH_REQUESTED: "DATA_REFRESH_REQUESTED",
};

// Pengaturan Simpanan (summary) - cache-first pattern mirip Simpanan Hari Raya
export const PENGATURAN_SIMPANAN_SUMMARY = {
  GET_DATA_PENGATURAN_SIMPANAN_SUCCESS: "GET_DATA_PENGATURAN_SIMPANAN_SUCCESS",
  LOADING_DATA_PENGATURAN_SIMPANAN_SUCCESS:
    "LOADING_DATA_PENGATURAN_SIMPANAN_SUCCESS",

  // Selection per halaman
  SET_QUERY_KEY: "PENGATURAN_SIMPANAN_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_SIMPANAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_SIMPANAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_SIMPANAN_CLEAR_SELECTED_IDS",

  // Cache helpers
  SET_CACHE_ENTRY: "PENGATURAN_SIMPANAN_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_SIMPANAN_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_SIMPANAN_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_SIMPANAN_UPDATE_CACHE_ITEMS",
};

export const PENGATURAN_SIMPANAN_MONTHLY = {
  GET_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
    "GET_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS",
  LOADING_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
    "LOADING_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS",

  // Selection per halaman
  SET_QUERY_KEY: "PENGATURAN_SIMPANAN_MONTHLY_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_CLEAR_SELECTED_IDS",

  // Cache helpers
  SET_CACHE_ENTRY: "PENGATURAN_SIMPANAN_MONTHLY_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_SIMPANAN_MONTHLY_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_SIMPANAN_MONTHLY_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_SIMPANAN_MONTHLY_UPDATE_CACHE_ITEMS",
};

// Loan Deferment module constants (isolated from other modules)
export const LOAN_DEFERMENT = {
  LOADING_ACTION: "LOAN_DEFERMENT_LOADING_ACTION",
  IS_MODAL_ACTION: "LOAN_DEFERMENT_IS_MODAL_ACTION",
  SET_QUERY_KEY: "LOAN_DEFERMENT_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "LOAN_DEFERMENT_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "LOAN_DEFERMENT_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "LOAN_DEFERMENT_CLEAR_SELECTED_IDS",
};

export const ADD_SIMPANAN_WAJIB = {
  GET_DATA_SIMPANAN_WAJIB_SUCCESS: "GET_DATA_SIMPANAN_WAJIB_SUCCESS",
  LOADING_DATA_SIMPANAN_WAJIB_SUCCESS: "LOADING_DATA_SIMPANAN_WAJIB_SUCCESS",
  ADD_SELECTED_IDS: "SIMPANAN_WAJIB_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_WAJIB_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_WAJIB_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SIMPANAN_WAJIB: "LOADING_ACTION_SIMPANAN_WAJIB",
  IS_MODAL_ACTION_SIMPANAN_WAJIB: "IS_MODAL_ACTION_SIMPANAN_WAJIB",

  SET_QUERY_KEY: "SIMPANAN_WAJIB_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SIMPANAN_WAJIB_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_WAJIB_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_WAJIB_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SIMPANAN_WAJIB_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SIMPANAN_WAJIB_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SIMPANAN_WAJIB_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SIMPANAN_WAJIB_UPDATE_CACHE_ITEMS",
  SIMPANAN_WAJIB_RESET: "SIMPANAN_WAJIB_RESET",
  SIMPANAN_WAJIB_SUCCESS: "SIMPANAN_WAJIB_SUCCESS",
};

export const ADD_SIMPANAN_POKOK = {
  GET_DATA_SIMPANAN_POKOK_SUCCESS: "GET_DATA_SIMPANAN_POKOK_SUCCESS",
  LOADING_DATA_SIMPANAN_POKOK_SUCCESS: "LOADING_DATA_SIMPANAN_POKOK_SUCCESS",
  ADD_SELECTED_IDS: "SIMPANAN_POKOK_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_POKOK_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_POKOK_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SIMPANAN_POKOK: "LOADING_ACTION_SIMPANAN_POKOK",
  IS_MODAL_ACTION_SIMPANAN_POKOK: "IS_MODAL_ACTION_SIMPANAN_POKOK",

  SET_QUERY_KEY: "SIMPANAN_POKOK_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SIMPANAN_POKOK_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_POKOK_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_POKOK_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SIMPANAN_POKOK_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SIMPANAN_POKOK_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SIMPANAN_POKOK_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SIMPANAN_POKOK_UPDATE_CACHE_ITEMS",
  SIMPANAN_POKOK_RESET: "SIMPANAN_POKOK_RESET",
  SIMPANAN_POKOK_SUCCESS: "SIMPANAN_POKOK_SUCCESS",
};

export const ADD_SUKARELA = {
  GET_DATA_SUKARELA_SUCCESS: "GET_DATA_SUKARELA_SUCCESS",
  LOADING_DATA_SUKARELA_SUCCESS: "LOADING_DATA_SUKARELA_SUCCESS",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SUKARELA: "LOADING_ACTION_SUKARELA",
  IS_MODAL_ACTION_SUKARELA: "IS_MODAL_ACTION_SUKARELA",

  SET_QUERY_KEY: "SUKARELA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SUKARELA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SUKARELA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SUKARELA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SUKARELA_UPDATE_CACHE_ITEMS",
  SUKARELA_RESET: "SUKARELA_RESET",
  SUKARELA_SUCCESS: "SUKARELA_SUCCESS",
};

export const ADD_SIHARA = {
  GET_DATA_SIHARA_SUCCESS: "GET_DATA_SIHARA_SUCCESS",
  LOADING_DATA_SIHARA_SUCCESS: "LOADING_DATA_SIHARA_SUCCESS",
  ADD_SELECTED_IDS: "SIHARA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIHARA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIHARA_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SIHARA: "LOADING_ACTION_SIHARA",
  IS_MODAL_ACTION_SIHARA: "IS_MODAL_ACTION_SIHARA",

  SET_QUERY_KEY: "SIHARA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SIHARA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIHARA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIHARA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SIHARA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SIHARA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SIHARA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SIHARA_UPDATE_CACHE_ITEMS",
  SIHARA_RESET: "SIHARA_RESET",
  SIHARA_SUCCESS: "SIHARA_SUCCESS",
};

export const SIMPANAN_HARI_RAYA_WITHDRAWALS = {
  LOADING_DATA_SIMPANAN_HARI_RAYA_WITHDRAWALS_SUCCESS:
    "LOADING_DATA_SIMPANAN_HARI_RAYA_WITHDRAWALS_SUCCESS",
  LOADING_ACTION_SIMPANAN_HARI_RAYA_WITHDRAWALS:
    "LOADING_ACTION_SIMPANAN_HARI_RAYA_WITHDRAWALS",
  IS_MODAL_ACTION_SIMPANAN_HARI_RAYA_WITHDRAWALS:
    "IS_MODAL_ACTION_SIMPANAN_HARI_RAYA_WITHDRAWALS",
  GET_DATA_SIMPANAN_HARI_RAYA_WITHDRAWALS_SUCCESS:
    "GET_DATA_SIMPANAN_HARI_RAYA_WITHDRAWALS_SUCCESS",

  SET_QUERY_KEY_WITHDRAWALS: "SET_QUERY_KEY_WITHDRAWALS",
  ADD_SELECTED_IDS_WITHDRAWALS: "ADD_SELECTED_IDS_WITHDRAWALS",
  REMOVE_SELECTED_IDS_WITHDRAWALS: "REMOVE_SELECTED_IDS_WITHDRAWALS",
  CLEAR_SELECTED_IDS_WITHDRAWALS: "CLEAR_SELECTED_IDS_WITHDRAWALS",

  SET_CACHE_ENTRY_WITHDRAWALS: "SET_CACHE_ENTRY_WITHDRAWALS",
  UPDATE_CACHE_ITEMS_WITHDRAWALS: "UPDATE_CACHE_ITEMS_WITHDRAWALS",

  WITHDRAWAL_ACTION_COMPLETED: "WITHDRAWAL_ACTION_COMPLETED",
  WITHDRAWAL_ACTION_FAILED: "WITHDRAWAL_ACTION_FAILED",
  DATA_REFRESH_REQUESTED_WITHDRAWALS: "DATA_REFRESH_REQUESTED_WITHDRAWALS",
};

export const PINJAMAN = {
  GET_DATA_PINJAMAN_SUCCESS: "GET_DATA_PINJAMAN_SUCCESS",
  LOADING_DATA_PINJAMAN_SUCCESS: "LOADING_DATA_PINJAMAN_SUCCESS",
  ADD_SELECTED_IDS: "PINJAMAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PINJAMAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PINJAMAN_CLEAR_SELECTED_IDS",

  LOADING_ACTION_PINJAMAN: "LOADING_ACTION_PINJAMAN",
  IS_MODAL_ACTION_PINJAMAN: "IS_MODAL_ACTION_PINJAMAN",

  SET_QUERY_KEY: "PINJAMAN_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PINJAMAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PINJAMAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PINJAMAN_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PINJAMAN_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PINJAMAN_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PINJAMAN_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PINJAMAN_UPDATE_CACHE_ITEMS",
  PINJAMAN_RESET: "PINJAMAN_RESET",
  PINJAMAN_SUCCESS: "PINJAMAN_SUCCESS",
};